import { render, staticRenderFns } from "./inner-tabs.vue?vue&type=template&id=3d373613&scoped=true"
import script from "./inner-tabs.vue?vue&type=script&lang=js"
export * from "./inner-tabs.vue?vue&type=script&lang=js"
import style0 from "./inner-tabs.vue?vue&type=style&index=0&id=3d373613&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d373613",
  null
  
)

export default component.exports